module.exports = __webpack_public_path__ + "img/感谢你已为10人投票成功.5b48335a.jpg";